/**
 * Small DOM helpers.
 *
 * `document.getElementById` returns `HTMLElement | null`, and the app touches
 * dozens of elements it knows exist because they are in index.html. `must`
 * asserts that once, loudly, instead of scattering null checks that would
 * silently no-op if an id were ever renamed.
 */

export function must<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing required element #${id}`);
  return el as T;
}

export function maybe<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

export function input(id: string): HTMLInputElement {
  return must<HTMLInputElement>(id);
}

export function select(id: string): HTMLSelectElement {
  return must<HTMLSelectElement>(id);
}

/** Binds a click handler, suppressing the default action for <a href="#">. */
export function onClick(id: string, handler: () => void): void {
  must(id).addEventListener('click', (event) => {
    event.preventDefault();
    handler();
  });
}
